// test1396
(1396 && 0);
